export default __webpack_public_path__ + "static/media/rightTick.9b14216e.png";